import { render } from "./TruckInfo.vue?vue&type=template&id=3a93b0c7"
import script from "./TruckInfo.vue?vue&type=script&lang=js"
export * from "./TruckInfo.vue?vue&type=script&lang=js"

import "./TruckInfo.vue?vue&type=style&index=0&id=3a93b0c7&lang=scss"

import exportComponent from "/opt/build/repo/access-trucks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__